export const CLOVER_AMEX = 'AMEX';
export const CLOVER_DISCOVER = 'DISCOVER';
export const CLOVER_MASTERCARD = 'MC';
export const CLOVER_VISA = 'VISA';

export const STRIPE_AMEX = 'American Express';
export const STRIPE_DISCOVER = 'Discover';
export const STRIPE_MASTERCARD = 'MasterCard';
export const STRIPE_VISA = 'Visa';
